import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'prototype_auth';

const PrototypeAuthContext = createContext(null);

export function PrototypeAuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    setIsAuthenticated(stored === 'true');
  }, []);

  const login = useCallback(() => {
    sessionStorage.setItem(STORAGE_KEY, 'true');
    setIsAuthenticated(true);
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem(STORAGE_KEY);
    setIsAuthenticated(false);
  }, []);

  return (
    <PrototypeAuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </PrototypeAuthContext.Provider>
  );
}

export function usePrototypeAuth() {
  const ctx = useContext(PrototypeAuthContext);
  if (!ctx) throw new Error('usePrototypeAuth must be used within PrototypeAuthProvider');
  return ctx;
}
